<template>
	<v-col class="background">
		<v-row>
			<v-col class="d-flex">
				<v-img :src="luckyLogo" alt="logo" contain height="200" />
			</v-col>
			<v-col class="d-flex">
				<v-img
					:src="winningNumbers"
					contain
					alt="winningNumbers"
					class="winning-numbers"
					width="400"
				/>
			</v-col>
			<v-col class="d-flex">
				<v-img :src="luckyLogo" alt="logo" contain height="200" />
			</v-col>
		</v-row>
		<v-row
			v-for="number in result.numbers"
			:key="number.playType.id"
			no-gutters
		>
			<v-col class="text-center" cols="4">
				<img
					:src="imageForPlayType(number.playType)"
					width="180"
					alt="playType"
					class="pick"
				/>
			</v-col>
			<v-col cols="8">
				<img
					v-for="(result, index) in number.digits"
					:key="index"
					:src="balls[parseInt(result, 10)]"
					height="80"
					alt="result"
					class="ball"
				/>
			</v-col>
		</v-row>
	</v-col>
</template>

<script>
import ResultField from '../../../../enumerations/ResultField.json';
import WinningNumbers from 'assets/static/img/labels/lucklotto/winning_numbers.png';
import LuckyLogo from 'assets/static/img/logo/lucklotto.png';
import ball0 from 'assets/static/img/balls/N0 200X200.png';
import ball1 from 'assets/static/img/balls/N1 200X200.png';
import ball2 from 'assets/static/img/balls/N2 200X200.png';
import ball3 from 'assets/static/img/balls/N3 200X200.png';
import ball4 from 'assets/static/img/balls/N4 200X200.png';
import ball5 from 'assets/static/img/balls/N5 200X200.png';
import ball6 from 'assets/static/img/balls/N6 200X200.png';
import ball7 from 'assets/static/img/balls/N7 200X200.png';
import ball8 from 'assets/static/img/balls/N8 200X200.png';
import ball9 from 'assets/static/img/balls/N9 200X200.png';
import pick2 from 'assets/static/img/picks/lucklotto/pick2.png';
import pick3 from 'assets/static/img/picks/lucklotto/pick3.png';
import pick4 from 'assets/static/img/picks/lucklotto/pick4.png';
import pick5 from 'assets/static/img/picks/lucklotto/pick5.png';

export default {
	name: 'WinningNumbers',
	props: {
		result: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			luckyLogo: LuckyLogo,
			winningNumbers: WinningNumbers,
			balls: [
				ball0,
				ball1,
				ball2,
				ball3,
				ball4,
				ball5,
				ball6,
				ball7,
				ball8,
				ball9
			]
		};
	},
	mounted() {
		this.$confetti.start();
	},
	destroyed() {
		this.$confetti.stop();
	},
	methods: {
		imageForPlayType(playType) {
			switch (playType.id) {
				case ResultField.PickTwo:
					return pick2;
				case ResultField.CashThree:
					return pick3;
				case ResultField.PickFour:
					return pick4;
				case ResultField.PickFive:
					return pick5;
			}
		}
	}
};
</script>
